import { LayoutDashboard, Calculator, Package, Users, HandCoins, Truck, BarChart3, Settings, FileText, Receipt } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface NavChild {
  id: string
  path: string
  labelKey: string
}

export interface NavItem {
  id: string
  path: string
  labelKey: string
  icon: LucideIcon
  children?: NavChild[]
}

export const NAV_ITEMS: NavItem[] = [
  { id: 'dashboard', path: '/dashboard', labelKey: 'desktopShell.nav.dashboard', icon: LayoutDashboard },
  {
    id: 'cashier',
    path: '/caisse',
    labelKey: 'desktopShell.nav.cashier',
    icon: Calculator,
    children: [
      { id: 'cashier-history', path: '/caisse/historique', labelKey: 'registerSales.history' },
      { id: 'cashier-journal', path: '/caisse/journal', labelKey: 'registerSales.cashJournalTitle' },
    ],
  },
  {
    id: 'stock',
    path: '/stock',
    labelKey: 'desktopShell.nav.stock',
    icon: Package,
    children: [
      { id: 'stock-import', path: '/stock/import', labelKey: 'inventoryCatalog.importCatalogTitle' },
      { id: 'stock-categories', path: '/stock/categories', labelKey: 'inventoryCatalog.categoriesTitle' },
      { id: 'stock-transfers', path: '/stock/transferts', labelKey: 'inventoryCatalog.stockTransfersTitle' },
      { id: 'stock-labels', path: '/stock/etiquettes', labelKey: 'labels.navTitle' },
    ],
  },
  {
    id: 'suppliers',
    path: '/fournisseurs',
    labelKey: 'desktopShell.nav.suppliers',
    icon: Truck,
    children: [
      { id: 'suppliers-arrival', path: '/stock/arrivage', labelKey: 'inventoryCatalog.newArrivalTitle' },
    ],
  },
  { id: 'resellers', path: '/revendeurs', labelKey: 'desktopShell.nav.resellers', icon: Users },
  {
    id: 'clients',
    path: '/clients',
    labelKey: 'desktopShell.nav.clients',
    icon: HandCoins,
    children: [
      { id: 'clients-directory', path: '/annuaire-clients', labelKey: 'desktopShell.nav.customerDirectory' },
    ],
  },
  { id: 'quotes', path: '/devis', labelKey: 'desktopShell.nav.quotes', icon: FileText },
  { id: 'invoices', path: '/factures', labelKey: 'desktopShell.nav.invoices', icon: Receipt },
  { id: 'stats', path: '/statistiques', labelKey: 'desktopShell.nav.stats', icon: BarChart3 },
  { id: 'settings', path: '/reglages', labelKey: 'desktopShell.nav.settings', icon: Settings },
]

export const SHOP_SWITCH_PATH = '/boutiques'
export const MY_PROFILE_PATH = '/mon-profil'
